module.exports = __webpack_public_path__ + "static/media/kfu.876ae8fb.jpg";